// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.system.global.js
// module id = ./node_modules/babel-polyfill/node_modules/core-js/modules/es7.system.global.js
// module chunks = 4